import actions from './actions.js';
import { TRIP_STATE } from '../../mutation-types';
import moment from 'moment';
import Vue from 'vue';

const initialState = {
    actualTrip: null,
    actualTripMetadata: null,
    tripsHistory: [],
    alreadyPlayedNotifications: {
        passengerAccepted: {},
        passengerCanceled: {},
        passengerTaxiArrived: {}
    },
    availableDrivers: {},
    requestPosition: null,
    timestamp: null,
    hasFirstRemoteState: false,
    canceledTrip: null,
    pendingReservation: null
};

const state = Object.assign({}, initialState);

const getters = {
    actualTrip: state => state.actualTrip,
    actualTripMetadata: state => state.actualTripMetadata,
    tripsHistory: state => state.tripsHistory,
    isRequesting: state => !state.actualTrip,
    isWaitingRequest: state => state.actualTrip && state.actualTrip.frontState === TRIP_STATE.PENDING,
    isAccepted: state => state.actualTrip && state.actualTrip.chofer,
    isRideUp: state => state.actualTrip && state.actualTrip.pasajeroAbordo,
    isDriverNear: state => state.actualTrip && state.actualTrip.llegando,
    requestPosition: state => state.actualTrip ? { lat: state.actualTrip.lat, lng: state.actualTrip.lng } : (state.requestPosition ? state.requestPosition : null),
    driverPosition: state => state.actualTrip && state.actualTrip.vehiculo ? { lat: state.actualTrip.vehiculo.lat, lng: state.actualTrip.vehiculo.lng } : null,
    alreadyPlayedNotifications: state => state.alreadyPlayedNotifications,
    availableDrivers: state => state.availableDrivers,
    hasFirstRemoteState: state => state.hasFirstRemoteState,
    canceledTrip: state => state.canceledTrip,
    pendingReservation: state => state.pendingReservation,
    isPendingReservationHome: state => !!(state.pendingReservation && state.pendingReservation.es_con_reserva)
};

const mutations = {
    RESET_STATES (state) {
        Object.assign(state, initialState);
    },

    SET_ACTUAL_TRIP (state, trip) {
        state.actualTrip = trip;
    },

    SET_ACTUAL_TRIP_METADATA (state, metadata) {
        state.actualTripMetadata = metadata;
    },

    SET_WAITING_REQUEST (state) {
        state.isWaitingRequest = true;
    },

    SET_HISTORY_TRIP (state, trips) {
        state.tripsHistory = trips;
    },

    ADD_HISTORY_TRIP (state, trip) {
        state.tripsHistory.push(trip);
    },

    REMOVE_HISTORY_TRIP (state, trip) {
        let index = state.tripsHistory.findIndex(item => item.id === trip.id);
        if (index >= 0) {
            state.tripsHistory.splice(index, 1);
        };
    },

    SET_PLAYED_NOTIFICATONS (state, action, tripId) {
        if (action && tripId) {
            state.alreadyPlayedNotifications[action][tripId] = true;
        }
    },

    MOVE_AVAILABLE_DRIVERS (state, { driver_id, point }) {

    },

    SET_FIRST_REMOTE_STATE (state) {
        state.hasFirstRemoteState = true;
    },

    MOVE_ONE_STEP (state) {
        for (let driverID in state.availableDrivers) {
            let driver = state.availableDrivers[driverID];
            if (driver.points.length > 0) {
                let p = driver.points.shift();
                driver.actual.lat = p.lat;
                driver.actual.lng = p.lng;
            }
        }
    },

    SET_AVAILABLE_DRIVERS (state, drivers) {
        for (let driver of drivers) {
            if (!state.availableDrivers[driver.id]) {
                Vue.set(state.availableDrivers, driver.id, {});

                Vue.set(state.availableDrivers[driver.id], 'actual', {
                    lat: driver.actual.lat,
                    lng: driver.actual.lng,
                    fecha: driver.actual.fecha
                });
                Vue.set(state.availableDrivers[driver.id], 'points', []);
            } else {
                let steps = (20 * 1000 / 250); // 20 segundos cada 0.2 segundos = 100 steps. Cada 20segs porque se refresca el estado.
                let pts = [];
                const ps = state.availableDrivers[driver.id].points;

                if (ps.length) {
                    pts.push(ps[ps.length - 1]);
                } else {
                    pts.push(state.availableDrivers[driver.id].actual);
                }
                for (let u of driver.ubicaciones) {
                    pts.push({ lat: u.lat, lng: u.lng });
                }
                pts.push({ lat: driver.actual.lat, lng: driver.actual.lng });
                let stepsPerPoints = steps / (pts.length - 1);
                for (let i = 1; i < pts.length; i++) {
                    const desde = pts[i - 1];
                    const hasta = pts[i];
                    for (let step = 1; step <= stepsPerPoints; step++) {
                        let lat = desde.lat + (step * (hasta.lat - desde.lat) / stepsPerPoints);
                        let lng = desde.lng + (step * (hasta.lng - desde.lng) / stepsPerPoints);
                        ps.push({ lng, lat });
                    }
                }
            }
        }
        for (let key in state.availableDrivers) {
            let i = drivers.findIndex((item) => String(item.id) === String(key));
            if (i < 0) {
                Vue.delete(state.availableDrivers, key);
            }
        }
    },

    SET_REQUEST_POSITION (state, position) {
        state.requestPosition = position;
    },

    SET_TIMESTAMP (state) {
        state.timestamp = moment().format('YYYY-MM-DD HH:mm:ss');
    },

    SET_CANCELED_TRIP (state, trip) {
        state.canceledTrip = trip;
    },

    SET_PENDING_RESERVATION (state, reservation) {
        state.pendingReservation = reservation;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/passenger/passenger.js